/// <reference types="vite/client" />

const SERVER_URL = import.meta.env.VITE_SERVER_URL || "http://localhost:3001";

export async function getBalance(playerId: string) {
  const res = await fetch(`${SERVER_URL}/play/GetBalance`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ playerId }),
  });
  if (!res.ok) throw new Error("Failed to fetch balance");
  return res.json();
}

export async function openBox(
  caseId: string,
  userId: string,
  amount: number,
  currency: string,
  winningNumber?: number | null,
  txHash?: string | null
) {
  const res = await fetch(`${SERVER_URL}/play/OpenBox`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      caseId,
      userId,
      amount,
      currency,
      txHash,
      winningNumber,
    }),
  });
  if (!res.ok) throw new Error("Failed to open box");
  return res.json();
}

export async function getOpenBoxResult(openingId: string) {
  const res = await fetch(`${SERVER_URL}/play/OpenBox?openingId=${openingId}`);
  if (!res.ok) throw new Error("Failed to fetch box result");
  return res.json();
}

export async function getBoxesCount(userId?: string) {
  const res = await fetch(
    `${SERVER_URL}/play/BoxesCount${userId ? `?userId=${userId}` : ""}`,
    {
      cache: "no-store", // always fresh
    }
  );
  if (!res.ok) throw new Error("Failed to fetch boxes count");
  return res.json() as Promise<{
    boxCounts: Record<string, number>;
    resetsAt: string;
  }>;
}

export async function getRecentPlays() {
  const res = await fetch(`${SERVER_URL}/play/RecentPlays`);
  if (!res.ok) throw new Error("Failed to fetch recent plays");
  return res.json() as Promise<{
    plays: {
      username: string;
      prizeAmount: number;
      prizeSymbol: string;
      prizeType: string;
      boxType: string;
      timeAgo: string;
    }[];
  }>;
}
